import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './theme/fonts.css';
// Дизайн-система КОММА (порт из support): CSS-переменные, компоненты, тёмная тема.
// Импортируется после fonts.css — правила global.css имеют приоритет над baseline.
import './styles/global.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Не найден #root в index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
